/*
 * Copyright (c) 2020 NOOGA DEVELOPMENT, All rights reserved.
 * Author Raman Kremko <raman.kremko@noogadev.com>
 */

import * as React from 'react';

interface CopyOwnProps {
    text: string;
    children: React.ReactNode;
    onCopy(text: string, result: boolean): void;
}

const copyToClipboard = (str: string) => {
    let success: boolean = false;
    const range = document.createRange();
    const selection = document.getSelection();

    selection.removeAllRanges();

    const el = document.createElement('span');

    el.textContent = str;
    el.setAttribute('readonly', '');
    el.style.position = 'absolute';
    el.style.left = '-9999px';
    document.body.appendChild(el);
    range.selectNodeContents(el);
    selection.addRange(range);

    const successful: boolean = document.execCommand('copy');

    if (successful) {
        success = true;
    }

    return success;
};

class Copy extends React.Component<CopyOwnProps> {
    onClick = () => {
        const { text, onCopy } = this.props;

        const result = copyToClipboard(text);

        if (onCopy) {
            onCopy(text, result);
        }
    };

    public render(): React.ReactNode {
        const { children } = this.props;
        const element = React.Children.only(children);

        return React.cloneElement(element as React.ReactElement, { onClick: this.onClick });
    }
}

export default Copy;
